import scenario from "planets/onis/onis-scenario.svg"
import flag from "planets/onis/onis-high-flag.svg"
import { stone0, stone1, stone2, stone3, stone4, stone5, stone6 } from "planets/onis/stone"

export default {
  stones: [stone0, stone1, stone2, stone3, stone4, stone5, stone6],
  scenario: scenario,
  flag: flag,
  gradient: "linear-gradient(180deg,#ff534d 0%,#ff7d00 100%)",
  paddingTop: "20px"
}
